import { render, staticRenderFns } from "./CoinNetworkTerms.vue?vue&type=template&id=72843c05&scoped=true&"
import script from "./CoinNetworkTerms.vue?vue&type=script&lang=ts&"
export * from "./CoinNetworkTerms.vue?vue&type=script&lang=ts&"
import style0 from "./CoinNetworkTerms.vue?vue&type=style&index=0&id=72843c05&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72843c05",
  null
  
)

export default component.exports